import React from "react";
import { BrowserRouter } from "react-router-dom";
import Routes from "./routes";
import history from "./history";

import GlobalStyle from "./styles/global";

function App() {
  return (
    <>
      <GlobalStyle />
      <BrowserRouter basename="/desafio">
        <Routes history={history} />
      </BrowserRouter>
    </>
  );
}

export default App;
